import React from 'react'
import { Link } from "react-router-dom";

function PageNotFound() {
   return (
      <section>
         <div class="d-flex flex-column container">
            <div class="min-vh-100 justify-content-center align-items-center row">
               <div class="py-8 py-xl-0 col-lg-10 offset-lg-1">
                  <div class="mb-10 mb-xxl-0"><a href="/">
                     <img src="/images/logo/freshcart-logo.svg" alt="" class="" />
                  </a></div><div class="justify-content-center align-items-center row">
                     <div class="col-md-6"><div class="mb-6 mb-lg-0">
                        <h1>Something’s wrong  </h1>
                        <p class="mb-8">We can’t find the page you’re looking for.</p>
                        <Link class="btn btn-dark text-white" to="/login">Back to Home</Link>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default PageNotFound